<template>
  <td class="soprts_in_acc_2 "
      :style="[width === 2 ? {'width': '50%'} : {'width': '33%'}]"
      :class="{'sel': checkCart(bets)}"
      @click="addCart(bets, folder, game)"
  >
    <div class="sports_v_l_1">
      {{ teamName }}
    </div>
    <div class="sports_v_r_1">
      <i v-if="priceStatus === 'up'" class="ico-up blink"></i>
      <i v-if="priceStatus === 'down'" class="ico-down blink"></i>
      <span class="font_002 ">
        {{ Number(bets.price).toFixed(2) }}
      </span>
      <i v-if="priceStatus" class="sel_old ">({{ startPrice }})</i>
    </div>
  </td>
</template>

<script>
export default {
  name: "Price",
  props: ['bets', 'folder', 'addCart', 'checkCart', 'game', 'team', 'width'],
  data: function(){
    return {
      startPrice: null,
      priceStatus: null,
    }
  },
  mounted() {
    console.log(this.width);
  },
  computed: {
    type: function(){
      let type = 'home';
      if (this.bets.name === 'W1' || this.bets.name === 'Home' || this.bets.name === 'Over' || this.bets.name === '1X' || this.bets.name === 'Odd' || this.bets.name === 'Yes') return 'home';
      if (this.bets.name === 'X' || this.bets.name === '12') return 'draw';
      if (this.bets.name === 'W2' || this.bets.name === 'Away' || this.bets.name === 'Under' || this.bets.name === 'X2' || this.bets.name === 'Odd' || this.bets.name === 'No') return 'away';
      return type
    },
    price: function(){
      return Number(this.bets.price).toFixed(2)
    },
    teamName: function(){
      const { market, name: folderName, marketId } = this.folder;
      const { name: betName, line, displayName } = this.bets;
      const marketName = market.nameEn;

      // Players Specials and Match Winner
      if (marketName.includes('Players Specials and Match Winner')) {
        return displayName;
      }

      // 농구 선수 스탯 (마켓 이름으로 체크)
      const basketballMarkets = [
        'Player Points', 'Player Rebounds', 'Player Assists',
        'Player Points and Assists', 'Player Points and Rebounds',
        'Player Assists and Rebounds', 'Player Points, Assists and Rebounds',
        'Player 1st Quarter Points', 'Player 1st FG Attempt', 'Player 1st FT Attempt'
      ];
      if (basketballMarkets.some(m => marketName.includes(m))) {
        const playerName = folderName.split(')')[0];
        if (betName === 'Over') return `${playerName}) 오버 (${line})`;
        if (betName === 'Under') return `${playerName}) 언더 (${line})`;
      }

      // 농구 선수 스탯 (마켓 ID로 체크)
      const basketballMarketIds = [13750, 13751, 13752, 13753, 13754, 13755, 13756, 13757, 13758, 13759, 13760, 13761, 13762, 14591, 14594];
      if (basketballMarketIds.includes(marketId)) {
        const playerName = folderName.split('(')[0];
        if (betName === 'Over') return `${playerName}) 오버 (${line})`;
        if (betName === 'Under') return `${playerName}) 언더 (${line})`;
      }

      // e스포츠 선수 스탯
      if (marketName.includes('Player Total Kills') || marketName.includes('Player Total Assists')) {
        const playerName = folderName.split(' ')[0];
        if (betName === 'Over') return `${playerName} 오버 (${line})`;
        if (betName === 'Under') return `${playerName} 언더 (${line})`;
      }

      // 일반 베팅 타입
      const teamName = this.team.nameKr || this.team.nameEn;
      const homeTeamName = this.game.homeTeam.nameKr || this.game.homeTeam.nameEn;
      const awayTeamName = this.game.awayTeam.nameKr || this.game.awayTeam.nameEn;

      const betTypeMap = {
        'Over': `오버 ${line}`,
        'Under': `언더 ${line}`,
        'X': '무',
        '1X': '1팀승 또는 무승부',
        '12': '1팀승 또는 2팀승',
        'X2': '무승부 또는 2팀승',
        'Odd': '홀',
        'Even': '짝',
        'Yes': '예',
        'No': '아니오',
        'NoGoal': '노골',
        'W1andOver': `${homeTeamName} & 오버 ${line}`,
        'W2andOver': `${awayTeamName} & 오버 ${line}`,
        'W1andUnder': `${homeTeamName} & 언더 ${line}`,
        'W2andUnder': `${awayTeamName} & 언더 ${line}`
      };

      if (betTypeMap[betName]) {
        return betTypeMap[betName];
      }

      if (['Home', 'Away'].includes(betName)) {
        return market.isHandicap === 'y' ? `${teamName} (${line})` : teamName;
      }

      return market.isHandicap === 'y' ? `${teamName} (${line})` : teamName;
    },
  },
  watch: {
    price: function(newVal, val){
      if (Number(newVal) - Number(val) < 0) this.priceStatus = 'up';
      if (Number(newVal) - Number(val) > 0) this.priceStatus = 'down';
      if (Number(newVal) !== Number(val)) this.startPrice = val;
    },
    priceStatus: function(){
      setTimeout(() => {
        this.priceStatus = null
        this.startPrice = null;
      } ,5000)
    },
  },
}
</script>

<style scoped>
.blink {
  animation: top-arrow-down 1s 10!important;
}
</style>
